/* Collection grid column switcher — lets shoppers pick 2/3/4 products per row.
 * Swaps the Dawn grid-column class on #product-grid, persists to localStorage,
 * and re-applies after Dawn's AJAX filter/sort re-renders the grid. */
class ColumnSwitcher extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'avartan:collection-columns';
  }

  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('.column-switcher__btn'));
    this.buttons.forEach((btn) => {
      btn.addEventListener('click', () => this.apply(btn.dataset.cols, true));
    });
    const saved = this.saved();
    if (saved) this.apply(saved, false);
    this.watchGrid();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  saved() {
    try {
      return localStorage.getItem(this.storageKey);
    } catch (e) {
      return null;
    }
  }

  apply(cols, persist) {
    cols = String(cols);
    if (!['2', '3', '4'].includes(cols)) return;
    const grid = document.getElementById('product-grid');
    if (grid) {
      grid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop');
      grid.classList.add('grid--' + cols + '-col-desktop');
    }
    this.buttons.forEach((btn) => {
      btn.classList.toggle('column-switcher__btn--active', btn.dataset.cols === cols);
      btn.setAttribute('aria-pressed', btn.dataset.cols === cols ? 'true' : 'false');
    });
    if (persist) {
      try {
        localStorage.setItem(this.storageKey, cols);
      } catch (e) {
        /* localStorage unavailable — choice just won't persist */
      }
    }
  }

  // Dawn replaces #ProductGridContainer's contents on filter/sort; re-apply then.
  watchGrid() {
    const container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    this.observer = new MutationObserver(() => {
      const saved = this.saved();
      if (saved) this.apply(saved, false);
    });
    this.observer.observe(container, { childList: true, subtree: true });
  }
}

if (!customElements.get('column-switcher')) {
  customElements.define('column-switcher', ColumnSwitcher);
}
